import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { brand } from '../config/brand';
import Logo from './Logo';

const navItems = [
  { to: '/', label: 'Home', end: true },
  { to: '/products', label: 'Products' },
  { to: '/kid-safe', label: 'Kid-Safe' },
  { to: '/enterprise', label: 'Enterprise' },
  { to: '/distributors', label: 'Distributors' },
  { to: '/about', label: 'About' },
  { to: '/blog', label: 'Insights' },
  { to: '/contact', label: 'Contact' },
];

const telHref = `tel:${brand.phone.replace(/\s|-/g, '')}`;

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-slate-100 bg-white/90 backdrop-blur">
      <div className="container-page flex h-16 items-center justify-between">
        <Link to="/" aria-label={`${brand.name} — home`}>
          <Logo variant="full" tone="dark" />
        </Link>
        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive ? 'text-brand-600' : 'text-slate-600 hover:text-brand-600'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <a
            href={telHref}
            className="ml-2 hidden items-center gap-1.5 rounded-md px-2.5 py-2 text-sm font-semibold text-brand-700 transition-colors hover:text-brand-500 xl:inline-flex"
            aria-label={`Call ${brand.name}`}
          >
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
              <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384Z" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            {brand.phone}
          </a>
          <Link to="/distributors" className="btn-primary ml-1">
            Become a Distributor
          </Link>
        </nav>
        <button
          className="rounded-md p-2 text-slate-700 lg:hidden"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {open ? (
              <path d="M6 6l12 12M6 18L18 6" strokeLinecap="round" />
            ) : (
              <path d="M4 6h16M4 12h16M4 18h16" strokeLinecap="round" />
            )}
          </svg>
        </button>
      </div>
      {open && (
        <div className="border-t border-slate-100 bg-white lg:hidden">
          <div className="container-page flex flex-col py-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2 text-sm font-medium ${
                    isActive ? 'bg-brand-50 text-brand-700' : 'text-slate-700'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <a href={telHref} className="rounded-md px-3 py-2 text-sm font-semibold text-brand-700">
              Call {brand.phone}
            </a>
            <Link to="/distributors" className="btn-primary my-2" onClick={() => setOpen(false)}>
              Become a Distributor
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
